import * as Yup from 'yup';

export const isDecimal = (value: string) =>
  /^-?\d+(\.\d+)?$/.test(value.trim());

export const INVALID_LAT_MESSAGE = `Latitude must be in decimal or DMS format (e.g: 9° 57' 45" N or 9.9625)`;
export const INVALID_LONG_MESSAGE = `Longitude must be in decimal or DMS format (e.g: 9° 57' 45" W or 9.9625)`;

export const validateLatitudeDms = () =>
  Yup.string()
    .test('latitude-dms-or-decimal', INVALID_LAT_MESSAGE, (value) => {
      if (!value) return false;
      if (isDecimal(value)) {
        const num = parseFloat(value);
        if (num >= -90 && num <= 90) return true;
        return false;
      }
      return /^([0-8]?[0-9]|90)°\s([0-5]?[0-9])'\s([0-5]?[0-9])"\s[N|S]$/.test(
        value
      );
    })
    .required('Required');

export const validateLongitudeDms = () =>
  Yup.string()
    .test('longitude-dms-or-decimal', INVALID_LONG_MESSAGE, (value) => {
      if (!value) return false;
      if (isDecimal(value)) {
        const num = parseFloat(value);
        if (num >= -180 && num <= 180) return true;
        return false;
      }
      return /^([0-9]?[0-9]|1[0-7][0-9]|180)°\s([0-5]?[0-9])'\s([0-5]?[0-9])"\s[E|W]$/.test(
        value
      );
    })
    .required('Required');
